import React from 'react';
import globalMessages from 'translations/messages';
import { QUESTION_TYPES } from 'shared/constants/survey';
import useFormatMessage from 'hooks/useFormatMessage';
import FieldResult from './FieldResult';
import OptionsResult from './OptionsResult';
import PageflowResult from './PageflowResult';

import messages from './messages';

const { COUNTRY, THUMBS, SENTIMENT, RADIO, CHECKBOX, ZIP, FIELD, NPS, GRADE } = QUESTION_TYPES;

const QuestionResults = ({
  title,
  question,
  surveyGroupId,
  displayedSurvey,
  periods,
  chartSettings,
  onChartSettingsChanged,
  contentSettings,
  onContentSettingsChanged,
  isReport,
  isPrint,
  addToReport,
  compare,
  refetchChartResults,
  onEdit,
  width,
  allowPersonalData,
  onSelectChartSegment,
  comparablePeriods,
}) => {
  const $t = useFormatMessage();
  const subTitles = [];

  if (question.dependencies?.length > 0) {
    subTitles.push(question.dependencies.map((dep, i) => $t(messages['dependent-subtitle'], {
      operator: i && question.dependencyOperator,
      answer: dep.answer ? `"${dep.answer}"` : dep.options.map(o => `"${o.title}"`).join(` ${$t(globalMessages.or)} `),
      question: dep.question.title,
    })).join(' '));
  }

  const combinedChartSettings = {
    ...(question.chartSettings || {}),
    ...(chartSettings || {}),
  };

  switch (question.type) {
    case COUNTRY:
    case 'SCORE':
    case 'META':
    case 'FUNNEL':
    case THUMBS:
    case SENTIMENT:
    case RADIO:
    case CHECKBOX:
    case NPS:
    case GRADE:
    case ZIP: {
      return (
        <OptionsResult
          title={title}
          subTitles={subTitles}
          question={question}
          periods={periods}
          chartSettings={combinedChartSettings}
          onChartSettingsChanged={onChartSettingsChanged}
          addToReport={addToReport}
          isReport={isReport}
          isPrint={isPrint}
          compare={compare}
          onEdit={onEdit}
          width={width}
          onSelectChartSegment={onSelectChartSegment}
          comparablePeriods={comparablePeriods}
        />
      );
    }
    case FIELD:
      return (
        <FieldResult
          title={title}
          subTitles={subTitles}
          question={question}
          surveyGroupId={surveyGroupId}
          displayedSurvey={displayedSurvey}
          periods={periods}
          chartSettings={combinedChartSettings}
          onChartSettingsChanged={onChartSettingsChanged}
          addToReport={addToReport}
          isReport={isReport}
          isPrint={isPrint}
          refetchChartResults={refetchChartResults}
          allowPersonalData={allowPersonalData}
          width={width}
          onSelectChartSegment={onSelectChartSegment}
        />
      );
    case 'PAGEFLOW':
      return (
        <PageflowResult
          title={title}
          segments={question.segments}
          contentSettings={contentSettings}
          onContentSettingsChanged={onContentSettingsChanged}
        />
      );
    default:
      return null;
  }
};

export default QuestionResults;
